import React from 'react';
import PropTypes from 'prop-types';

import { ContractType } from '../../../../utils/userContract';
import BaseContractModal from '../../BaseContractModal';
import OneTimeContractModalContent from './OneTimeContractModalContent';

const OneTimeContractModal = ({ showModal, onClose }) => (
  <BaseContractModal
    showModal={showModal}
    onClose={onClose}
    contractType={ContractType.ONE_TIME}
  >
    <OneTimeContractModalContent />
  </BaseContractModal>
);

OneTimeContractModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OneTimeContractModal;
